import { useState } from 'react';

import { ReactComponent as IconSettingSlider } from 'assets/images/icons/settings-slider.svg';

import { AdvancedConfigurationModal } from 'components/AdvancedConfiguration/AdvancedConfigurationModal';
import { IconButton, Modal } from 'components/common';
import { IconType } from 'components/common/button/types';

import { AdvancedConfiguration as Configuration } from 'modules/performance/performanceApiTypes';

import { useOrganization } from '../../modules/organization/useOrganization';
import { DSP_AMAZON, DSP_CRITEO, DSP_VISTAR } from '../../utils/constants';

export const AdvancedConfiguration = ({
  advancedConfiguration,
  onChange,
}: {
  advancedConfiguration: Configuration;
  onChange: (data: Configuration) => void;
}) => {
  const { dsp } = useOrganization();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const handleModalAction = (isOpen: boolean) => setIsOpenModal(isOpen);

  if (dsp === DSP_VISTAR || dsp === DSP_CRITEO || dsp === DSP_AMAZON) return null;

  return (
    <>
      <IconButton
        className="ml-2"
        size="md"
        variant="outline"
        Icon={IconSettingSlider as IconType}
        onClick={() => handleModalAction(true)}
      />
      <Modal open={isOpenModal} closable={false} footer={null} destroyOnClose>
        <AdvancedConfigurationModal
          advancedConfiguration={advancedConfiguration}
          onClose={() => handleModalAction(false)}
          onSubmit={onChange}
        />
      </Modal>
    </>
  );
};
